export const NEWSLETTER_ENABLED_LINKS = [
  'newsletter',
  'newsletterAlerts',
  'newsletterSignUp',
];
